import { HttpRequestWrapper } from "../HttpRequestWrapper";
import { NewformaApiClient } from "./NewformaApiClient";
import { UserDataResponse } from "../../models/UserDataResponse";

export class AuthApiService {
    private readonly authUri = "/v1";
    private cachedUserData?: UserDataResponse;
    private pendingUserDataRequest?: Promise<UserDataResponse>;
    private userDataCacheVersion = 0;
    private userDataAccessCount = 0;

    constructor(private newformaApiClient: NewformaApiClient, private requestWrapper: HttpRequestWrapper) {}

    clearUserDataCache(): void {
        this.userDataCacheVersion += 1;
        this.cachedUserData = undefined;
        this.pendingUserDataRequest = undefined;
    }

    async getUserData(): Promise<UserDataResponse> {
        this.userDataAccessCount += 1;
        const accessLabel = `[CultureAccess ${this.userDataAccessCount}]`;

        if (this.cachedUserData) {
            return this.cachedUserData;
        }

        if (this.pendingUserDataRequest) {
            return this.pendingUserDataRequest;
        }

        const url = `${this.newformaApiClient.getHostNameWithProtocol()}${this.authUri}/me`;
        const options = {
            url: url,
            method: "GET",
            headers: { "x-newforma-agent": this.newformaApiClient.getNewformaAgent() },
        };

        const requestCacheVersion = this.userDataCacheVersion;

        const userDataRequest = this.newformaApiClient
            .makeRequest(options, async (signedOptions) =>
                this.requestWrapper.get(url, undefined, signedOptions.headers, undefined)
            )
            .then((response) => {
                if (requestCacheVersion === this.userDataCacheVersion) {
                    this.cachedUserData = response;
                }
                return response;
            })
            .finally(() => {
                if (this.pendingUserDataRequest === userDataRequest) {
                    this.pendingUserDataRequest = undefined;
                }
            });

        this.pendingUserDataRequest = userDataRequest;
        return this.pendingUserDataRequest;
    }
}
